import { apiClient } from '@/lib/api-client';
import type { ApiSuccess } from '@/lib/api-client';
import type { ReclassifiedReceiptDto } from './types';

/**
 * Read-only legacy reclassified item receipt API.
 *
 * Historical endpoints retained by reclassified_receipts/routes.rs:
 *   GET  /api/disassembly-batches/:id/reclassified-receipts  — list for batch
 *   GET  /api/reclassified-receipts/:id                      — read one
 *
 * New intermediate inventory is handled by the canonical dismantling flow.
 */

/** GET the disassembly batch's reclassified receipts. */
export const fetchReclassifiedReceipts = async (
  disassemblyBatchId: string,
): Promise<ReclassifiedReceiptDto[]> => {
  const res = await apiClient.get<ApiSuccess<ReclassifiedReceiptDto[]>>(
    `/disassembly-batches/${disassemblyBatchId}/reclassified-receipts`,
  );
  return res.data.data ?? [];
};
